@if (cards$ | async; as cards) {
  <section
    class="notification-cards"
    aria-live="polite"
    aria-label="Recent notifications"
  >
    @for (notification of cards; track notification.notificationId) {
      <article
        class="notification-cards__card"
        [ngClass]="'notification-cards__card--' + getTone(notification)"
      >
        <button
          class="notification-cards__open"
          type="button"
          (click)="onOpen(notification)"
        >
          <span class="notification-cards__icon" aria-hidden="true">
            <i
              [sch-icon]="
                notification.requiresAction ? 'note-approve' : 'info-outline'
              "
            ></i>
          </span>
          <span class="notification-cards__body">
            <strong>{{ notification.title }}</strong>
            <span>{{ notification.body }}</span>
          </span>
        </button>
        <button
          class="notification-cards__dismiss"
          type="button"
          aria-label="Dismiss notification"
          (click)="onDismiss(notification, $event)"
        >
          <i sch-icon="close"></i>
        </button>
      </article>
    }
  </section>
}
